import { render, staticRenderFns } from "./UseImmediate.vue?vue&type=template&id=12f66418&scoped=true&"
import script from "./UseImmediate.vue?vue&type=script&lang=js&"
export * from "./UseImmediate.vue?vue&type=script&lang=js&"
import style0 from "./UseImmediate.vue?vue&type=style&index=0&id=12f66418&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f66418",
  null
  
)

export default component.exports